"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyGetMaintenanceUssdLogsQuery = exports.useGetMaintenanceUssdLogsQuery = exports.useResetStuckTransactionsMutation = exports.useRetryFailedMutation = exports.useClearQueueMutation = exports.useGetErrorLogsQuery = exports.useGetQueueStatsQuery = exports.useRestartModemMutation = exports.useGetModemStatusQuery = exports.useDeleteUssdConfigMutation = exports.useUpdateUssdConfigMutation = exports.useCreateUssdConfigMutation = exports.useGetUssdConfigQuery = exports.useLazyGetUssdConfigsQuery = exports.useGetUssdConfigsQuery = exports.ussdApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.ussdApi = (0, react_1.createApi)({
    reducerPath: "ussdApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["UssdConfigs", "Modems", "UssdQueue"],
    endpoints: function (builder) { return ({
        getUssdConfigs: builder.query({
            query: function (params) { return ({
                url: "/v1/ussd/configs",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                return ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.data)
                    ? __spreadArray(__spreadArray([], result.content.data.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "UssdConfigs",
                            id: _id,
                        });
                    }), true), [
                        { type: "UssdConfigs", id: "LIST" },
                    ], false) : [{ type: "UssdConfigs", id: "LIST" }];
            },
        }),
        getUssdConfig: builder.query({
            query: function (id) { return "/v1/ussd/configs/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "UssdConfigs", id: id }]; },
        }),
        createUssdConfig: builder.mutation({
            query: function (data) { return ({
                url: "/v1/ussd/configs",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "UssdConfigs", id: "LIST" }],
        }),
        updateUssdConfig: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/ussd/configs/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "UssdConfigs", id: id },
                    { type: "UssdConfigs", id: "LIST" },
                ];
            },
        }),
        deleteUssdConfig: builder.mutation({
            query: function (id) { return ({
                url: "/v1/ussd/configs/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "UssdConfigs", id: "LIST" }],
        }),
        getModemStatus: builder.query({
            query: function () { return "/v1/ussd/modems"; },
            providesTags: [{ type: "Modems", id: "LIST" }],
        }),
        restartModem: builder.mutation({
            query: function (modemId) { return ({
                url: "/v1/ussd/modems/".concat(modemId, "/restart"),
                method: "POST",
            }); },
            invalidatesTags: [{ type: "Modems", id: "LIST" }],
        }),
        getQueueStats: builder.query({
            query: function () { return "/v1/ussd/queue/stats"; },
            providesTags: [{ type: "UssdQueue", id: "STATS" }],
        }),
        getErrorLogs: builder.query({
            query: function (params) { return ({
                url: "/v1/ussd/logs/errors",
                params: params,
            }); },
        }),
        clearQueue: builder.mutation({
            query: function () { return ({
                url: "/v1/ussd/queue/clear",
                method: "POST",
            }); },
            invalidatesTags: [{ type: "UssdQueue", id: "STATS" }],
        }),
        retryFailed: builder.mutation({
            query: function (arg) {
                var _a;
                return ({
                    url: "/v1/ussd/queue/retry-failed",
                    method: "POST",
                    body: { mode: (_a = arg === null || arg === void 0 ? void 0 : arg.mode) !== null && _a !== void 0 ? _a : "new" },
                });
            },
            invalidatesTags: [{ type: "UssdQueue", id: "STATS" }],
        }),
        resetStuckTransactions: builder.mutation({
            query: function (data) { return ({
                url: "/v1/ussd/queue/reset-stuck",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "UssdQueue", id: "STATS" }],
        }),
        getMaintenanceUssdLogs: builder.query({
            query: function (params) { return ({
                url: "/v1/ussd/logs",
                params: params,
            }); },
        }),
    }); },
});
exports.useGetUssdConfigsQuery = exports.ussdApi.useGetUssdConfigsQuery, exports.useLazyGetUssdConfigsQuery = exports.ussdApi.useLazyGetUssdConfigsQuery, exports.useGetUssdConfigQuery = exports.ussdApi.useGetUssdConfigQuery, exports.useCreateUssdConfigMutation = exports.ussdApi.useCreateUssdConfigMutation, exports.useUpdateUssdConfigMutation = exports.ussdApi.useUpdateUssdConfigMutation, exports.useDeleteUssdConfigMutation = exports.ussdApi.useDeleteUssdConfigMutation, exports.useGetModemStatusQuery = exports.ussdApi.useGetModemStatusQuery, exports.useRestartModemMutation = exports.ussdApi.useRestartModemMutation, exports.useGetQueueStatsQuery = exports.ussdApi.useGetQueueStatsQuery, exports.useGetErrorLogsQuery = exports.ussdApi.useGetErrorLogsQuery, exports.useClearQueueMutation = exports.ussdApi.useClearQueueMutation, exports.useRetryFailedMutation = exports.ussdApi.useRetryFailedMutation, exports.useResetStuckTransactionsMutation = exports.ussdApi.useResetStuckTransactionsMutation, exports.useGetMaintenanceUssdLogsQuery = exports.ussdApi.useGetMaintenanceUssdLogsQuery, exports.useLazyGetMaintenanceUssdLogsQuery = exports.ussdApi.useLazyGetMaintenanceUssdLogsQuery;
